import { PenLine } from "lucide-react";

const SAVE_LABEL = { saving: "Saving…", saved: "Saved ✓", idle: "Auto-saves" };

export const ReflectionWorkbook = ({ mod, answers, saveState, onAnswerChange }) => (
  <div className="w-full max-w-2xl bg-white/90 backdrop-blur-md border border-[#E7DFD5] shadow-[0_8px_30px_rgba(44,39,32,0.06)] rounded-2xl p-8 md:p-10" data-testid="cinematic-workbook">
    <div className="flex items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] uppercase text-[#B45309]">
        <PenLine size={12} /> Reflection — your workbook
      </div>
      <span data-testid="workbook-save-status" className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#44403C] shrink-0">
        {SAVE_LABEL[saveState] || SAVE_LABEL.idle}
      </span>
    </div>
    <p className="text-[#78716C] text-sm leading-relaxed mb-7">
      Write your answers below — they save to your account automatically, so you can leave and come back anytime. No rush — honesty is how you heal.
    </p>
    <ol className="space-y-8 list-none m-0 p-0">
      {mod.questions.map((q, i) => (
        <li key={q.slice(0, 24)} data-testid={`workbook-q-${mod.id}-${i + 1}`}>
          <div className="flex gap-4 mb-3">
            <span className="font-mono text-xs text-[#B45309] mt-1.5 shrink-0">{String(i + 1).padStart(2, "0")}</span>
            <span className="text-[#44403C] text-base md:text-lg leading-relaxed">{q}</span>
          </div>
          <textarea
            value={answers[i] || ""}
            onChange={(e) => onAnswerChange(i, e.target.value)}
            placeholder="Write your answer here…"
            rows={3}
            data-testid={`workbook-answer-${mod.id}-${i}`}
            className="w-full md:ml-9 md:w-[calc(100%-2.25rem)] bg-[#FAF7F2] border border-[#E7DFD5] focus:border-[#F59E0B]/60 focus:outline-none rounded-md p-3 text-[#1C1917] text-sm leading-relaxed resize-y transition-colors placeholder:text-[#A8A29E]"
          />
        </li>
      ))}
    </ol>
  </div>
);
